import type { Contract } from '../types'
import { meteringCheck } from './meteringCheck'

export const buildAwsMeteringDimensions = (
  tempObject: Contract[],
  shouldCheckAdditional?: boolean
) => {
  const dimensions = []
  for (const contract of tempObject) {
    const entitlementRows = contract?.entitlements?.rows || []
    for (const row of entitlementRows) {
      if (meteringCheck(row, shouldCheckAdditional)) {
        dimensions.push({
          labra_subscription_id: contract.id,
          dimension_name: row.dimensionName,
          quantity: row.meteringQuantityConsumed,
        })
      }
    }
  }
  return dimensions
}
